/* eslint-disable prefer-destructuring */
function getEnv () {
  if (process.env.AWP_DEPLOY_ENV) {
    const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV
    switch (AWP_DEPLOY_ENV) {
      case 'newtest':
      case 'test01':
      case 'test02':
        return 'test'
      case 'staging':
        return 'st'
      case 'production':
        return 'prod'
      default:
        console.log('使用域名判断环境')
    }
  }
  const host = window.location.host
  if (host.includes('mykeeta.test.sankuai.com') || host.includes('localhost')) {
    return 'test'
  } else if (host.includes('mykeeta.st.sankuai.com')) {
    return 'st'
  }
  return 'prod'
}
export const envs = {
  isTest: getEnv() === 'test',
}

const HOSTS_MAP = {
  'test': {
    'BASE': '',
    YODA: 'https://verify-i.inf.test.sankuai.com',
    'MOCK': 'https://f1-better.sankuai.com/mock/419',
  },
  'st': {
    'BASE': '',
    YODA: 'https://verify-in.st.meituan.com',
    'MOCK': '',
  },
  'prod': {
    YODA: 'https://verify.mykeeta.com',
    'BASE': '',
    'MOCK': '',
  },
}

export const HOSTS = HOSTS_MAP[getEnv()] || HOSTS_MAP.prod